import { Events } from 'global/constants';

// Array.from is there for IE11 compatibility. NodeList API does not have a forEach method in IE11.

const orderHistoryAddProductsSelectAll = () => {
	setupSelectAll();
	window.od.events.subscribe(
		Events.ADD_PRODUCTS_SELECTED_PRODUCTS_UPDATE,
		notify,
	);
};

const notify = ({ cartEntries }) => {
	const selectAllCheckbox = document.querySelector(
		'[data-id="selectAllProducts"]',
	);
	const productReorderCheckboxes = Array.from(
		document.querySelectorAll('[data-product-add-checkbox]'),
	);
	const numEnabledCheckboxes = productReorderCheckboxes.reduce(
		(accumulator, checkbox) => (checkbox.disabled ? 0 : 1) + accumulator,
		0,
	);
	if (numEnabledCheckboxes !== cartEntries.length) {
		selectAllCheckbox.checked = false;
	}
};

const setupSelectAll = () => {
	const selectAllCheckbox = document.querySelector(
		'[data-id="selectAllProducts"]',
	);
	if (selectAllCheckbox) {
		selectAllCheckbox.addEventListener('change', handleSelectAll);
	}
};

const handleSelectAll = () => {
	const selectAllCheckbox = document.querySelector(
		'[data-id="selectAllProducts"]',
	);
	const productReorderCheckboxes = document.querySelectorAll(
		'[data-product-add-checkbox]',
	);
	if (selectAllCheckbox.checked) {
		selectAll(productReorderCheckboxes);
	} else {
		deselectAll(productReorderCheckboxes);
	}
	window.od.events.publish(Events.ADD_PRODUCTS_SELECTED_PRODUCTS_CHANGED);
};

const selectAll = productReorderCheckboxes => {
	productReorderCheckboxes.forEach(productReorderCheckbox => {
		if (!productReorderCheckbox.disabled) {
			productReorderCheckbox.checked = true;
		}
	});
};

const deselectAll = productReorderCheckboxes => {
	productReorderCheckboxes.forEach(productReorderCheckbox => {
		productReorderCheckbox.checked = false;
	});
};

export {
	orderHistoryAddProductsSelectAll as default,
	handleSelectAll,
	selectAll,
	deselectAll,
};
